import React, {useContext} from "react";
import {observer} from "mobx-react-lite";
import staticIcon from "../../../assets/img/alt/static_code.png";
import lodash from 'lodash';

import {
  Card,
  CardBody,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  Button,
  DropdownItem,
  Badge,
  UncontrolledTooltip,
  UncontrolledButtonDropdown,
  DropdownToggle, DropdownMenu, CustomInput, PopoverHeader, PopoverBody, UncontrolledDropdown
} from "reactstrap";

//Our Custom Components
import ScanbuyTable, {TableColumn} from "../../tables/ScanbuyTable";
import TagSelect from "../../elements/tags/TagSelect";
import QrTemplateSelect from "../../elements/qrtemplates/QrTemplateSelect";
import CodeFilterSelect from "../../elements/filters/CodeFilterSelect";
import {RouterLink, useRouterStore} from "mobx-state-router";
import TableActionsDropdown from "../../tables/TableActionsDropdown";
import * as Icon from "react-feather";
import GenericModal from "../../elements/modal/GenericModal";
import PublishView from "../publish/PublishView";
import PublishState from "../publish/PublishState";
import DeleteState from "../delete/DeleteState";
import DeleteView from "../delete/DeleteView";
import dayjs from 'dayjs';
import GenericToastView from "../../elements/toast/GenericToastView";
import QrPreviewState from "../../qr/qrpreview/QrPreviewState";
import {StateContext} from "../../../App";
import {useIntl, FormattedMessage} from "react-intl";
import {getSnapshot} from "mobx-state-tree";

import CodeOwnerFilterSelect from "../../elements/filters/CodeOwnerFilterSelect";
import PreviewCodeAndEditDesign from "../view/PreviewCodeAndEditDesign";
import {PreviewCodeAndEditDesignState} from "../view/PreviewCodeAndEditDesignState";
import DesignerState from "../../qr/designer/DesignerState";
import ColorState from "../../qr/designer/color/ColorState";
import EyesAndModulesState from "../../qr/designer/eyesAndModules/EyesAndModulesState";
import LogoState from "../../qr/designer/logo/LogoState";
import ImageAndCharacteristicsState from "../../qr/designer/imageAndCharacteristics/ImageAndCharacteristicsState";
import FrameAndCaptionsState from "../../qr/designer/frameAndCaption/FrameAndCaptionsState";
import {v4 as uuidv4} from 'uuid';
import CaptionState from "../../qr/designer/frameAndCaption/CaptionState";
import CreateQrFromTemplateState from '../../qrTemplates/CreateQrFromTemplateState'
import CreateQrFromTemplateView from '../../qrTemplates/CreateQrFromTemplateView'
import {CODE_PUBLISH_SET, codeBehavior, codeStatus, formConstants, Roles} from "../../../utils/constants";
import {createdByColumn, updatedByColumn, hasRulesColumn, auditStatusColumn} from "../../tables/TableColumns"
import {buildDimensionFilters} from "../../../utils/buildDimensionFilters";
import Notification from "../../../utils/Notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faAngleDoubleDown, faAngleDoubleUp, faRotateLeft, faRotateRight, faIdBadge, faSlidersH} from "@fortawesome/free-solid-svg-icons";
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import GroupSelect from "../../elements/groups/GroupSelect";
import TagFilterSelect from "../../elements/filters/TagFilterSelect";
import {QrDownloadState} from "../../qr/qrpreview/qrDownload/QrDownloadState";
import GenericModal2 from "../../elements/modal2/GenericModal2";
import GroupFilterSelect from "../../elements/filters/GroupFilterSelect";
import ExportButton from "../../data/exports/button/ExportButton";
import {requiredRolesCheck} from "../../../utils/requiredRolesCheck";
import CompleteView from "../complete/CompleteView";
import CompleteState from "../complete/CompleteState";
import { MediaFileSelectState } from "src/components/elements/mediaFiles/MediaFileSelectState";
import {MediaFile} from "src/models/mediaFiles/MediaFileModel";
import {initDesignerViewState} from "../../qr/designer/utils/DesignerTemplateUtil";
import AuditView, {buildAuditColumns} from "../audit/AuditView";
import AuditViewState from "../audit/AuditViewState";
import { ReactComponent as BadgeCheckIcon } from '../../../../src/assets/img/alt/badge-check-regular.svg';
import OptionalColumnsDropdown from "../../elements/dropdown/OptionalColumnsDropdown";
import {buildColumnsWithOptionalSupport} from "../../../utils/optionalColumnsHelper";

/**
 * Shared function to initialize preview modal state for code preview
 * Used by both Preview button onClick and onRowClicked
 */
const initPreviewModalState = async (params) => {
  const {
    rowSnapshot,
    rootStore,
    qrConfigSelectStore,
    qrConfigStore,
    codeListState,
    mediaFileSelectState,
    dimensionsMultiSelectStore,
    tagSelectStore
  } = params;

  // Initialize designer view state
  const designerViewState = initDesignerViewState(
    getSnapshot(rootStore.domainStore.dashboardStore),
    qrConfigSelectStore,
    rootStore.rootUiStore.groupSelectStore,
    false,
    mediaFileSelectState,
    dimensionsMultiSelectStore,
    tagSelectStore
  );

  // Create QR preview store with default configs
  const qrPreviewStore = QrPreviewState.create({
    title: rowSnapshot.name,
    shortUrl: rowSnapshot.behavior === codeBehavior.STATIC
      ? rowSnapshot.shortUrl.uri
      : rowSnapshot.shortUrl.domain + "/" + rowSnapshot.shortUrl.uri,
    ableToEditConfig: false,
    qrConfigStore: qrConfigStore,
    qrConfigSelectStore: qrConfigSelectStore,
    qrType: rowSnapshot?.type,
    experienceData: rowSnapshot?.data,
    qrDownloadStore: QrDownloadState.create({}),
    defaultImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.defaultImageConfig,
    v1ImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.v1ImageConfig
  });

  // Create preview and edit design state
  const previewCodeAndEditDesignState = PreviewCodeAndEditDesignState.create({
    codeUuid: rowSnapshot.uuid,
    groupUuid: rowSnapshot.owner.groupUuid,
    defaultImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.defaultImageConfig,
    v1ImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.v1ImageConfig
  });

  // Attach page states
  rootStore.rootUiStore.attachPageState('qrPreviewStore', qrPreviewStore);
  rootStore.rootUiStore.attachPageState('designerViewState', designerViewState);
  rootStore.rootUiStore.attachPageState('previewCodeAndEditDesignState', previewCodeAndEditDesignState);

  // Set modal size listener
  previewCodeAndEditDesignState.setCodeListModalSizeListener(codeListState.setEditModalMode);

  // Set selected group and remove image config
  await qrConfigSelectStore.setSelectedGroup(rowSnapshot.owner.groupUuid);
  qrConfigSelectStore.configStore.removeImageConfig();

  // Check if code has saved image config
  const imageUuid = rowSnapshot?.images?.configs[0]?.uuid;
  if (imageUuid) {
    // Load saved config
    const res = await qrConfigSelectStore.configStore.fetchImageConfigWithId(imageUuid);
    qrConfigSelectStore?.setHydrateModal(designerViewState?.hydrateEditComponent);
    qrPreviewStore?.setQRImageFormData(res?.qrConfig);
    qrConfigSelectStore.setSelectedConfig(res);
  } else {
    if (qrPreviewStore.defaultImageConfig) {
      qrPreviewStore.setQRImageFormData(JSON.stringify(qrPreviewStore.defaultImageConfig));
    } else {
      qrPreviewStore.generateImage();
    }
    qrConfigSelectStore.setSelectedConfig("");
  }

  return { qrPreviewStore, designerViewState, previewCodeAndEditDesignState };
};

export const buildColumns = (routerStore, codeListViewState) => {
  const {rootStore} = routerStore.options;
  const userRoles = rootStore.userRoles
  const visible = new Set(codeListViewState.optionalColumns);

  const codeTypeStore = rootStore.domainStore.codeTypeStore;
  const codeTypes = codeTypeStore.codeTypes;

  const typeMap = lodash.keyBy(codeTypes, "name")
  const mediaFileSelectState = rootStore.rootUiStore.mediaFileSelectState;

  const auditOptions = rootStore?.appConfigs?.configs?.audit_options || [];

  console.log(typeMap);
  const staticImg = <img className="static-code-icon" alt="static icon" src={staticIcon}/>
  const c1 = TableColumn.create({
    name: 'Code Name', property: 'name', width: '20%', sortable: true, sortField: 'name',
  })
  c1.setSelector((row)=> {
    return (
      <>
        <div className="code-name-container">
        <span
          id={`tooltip-${row.uuid}`}
          className="code-name-text"
        >
          {row.name}
        </span>
          {row.behavior === codeBehavior.STATIC && (
            <span className="code-icon-wrapper">{staticImg}</span>
          )}
        </div>

        <UncontrolledTooltip target={`tooltip-${row.uuid}`} placement="top">
          {row.name}
        </UncontrolledTooltip>
      </>
    )
  })

  const c2 = TableColumn.create({
    name: 'Status', property: 'status', sortable: true, sortField: 'status', selector: 'status', width: '100px',
  })
  c2.setSelector((row) => {
    return row.status
  })

  const c3 = TableColumn.create({
    name: 'Code Experience', property: 'type', width: '120px',
  });
  c3.setSelector((row) => {
    let label = row.type;
    if (typeMap[row.type]) {
      label = typeMap[row.type].label || row.type;
    }

    return label;
  });

  const c4 = TableColumn.create({
    name: 'Create Date', property: 'created', width: '15%', hide: 'sm', sortable: true, sortField: 'createdAt',
  });
  c4.setSelector((row) => {
    // console.log(row)
    const {createdAt} = row || {};
    const formattedCreateDate = dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedCreateDate;
  });

  const updatedColumn = TableColumn.create({
    name: 'Last Modified', property: 'updated', width: '15%', hide: 'sm', sortable: true, sortField: 'updatedAt',
  });
  updatedColumn.setSelector((row) => {
    // console.log(row)
    const {updatedAt} = row || {};
    const formattedUpdateDate = dayjs(updatedAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedUpdateDate;
  });

  const c5 = TableColumn.create({
    name: 'Tag(s)', property: 'tags', hide: 'sm'
  });
  c5.setSelector((row) => {
    return row.tags;
  });
  c5.setCell((row) => {
    const tags = row.tags.flatMap((t) => {
      return {uuid: t.uuid, name: t.name, color: t.uiStyleConfigs?.color || 'info'}
    });
    const createTagBadge = (tag, index) => {
      const tagID = `tooltip-tag-${tag.uuid?.replace(".", "-")}`; // replace "." in ID for querySelector
      return (
        <>
          <Badge
            id={tagID}
            key={index}
            color="info"
            className="badge-pill mr-1 mb-1 d-block text-truncate"
          >
            {tag.name}
          </Badge>
          <UncontrolledTooltip target={tagID} placement="top">
            {tag.name}
          </UncontrolledTooltip>
        </>
      )
    };
    return tags.map(createTagBadge);
  })

  const createdBy = createdByColumn();

  const updatedBy = updatedByColumn();

  const hasRules = hasRulesColumn();

  const auditStatus = auditStatusColumn(auditOptions);

  const actionCol = TableColumn.create({
    name: 'Action', property: 'action', allowOverflow: true, button: true, width: '100px',
  })

  actionCol.setCell((row) => (<TableActionsDropdown
    actionsList={[
      <DropdownItem id={"action-btn-preview"+row} key={'preview' + row.uuid} value={'preview ' + row.uuid}
                    onClick={async () => {
                      // Snapshot row data immediately to avoid MST "no longer part of state tree" errors
                      const rowSnapshot = getSnapshot(row)
                      const qrConfigSelectStore = rootStore.rootUiStore.qrConfigSelectStore
                      const qrConfigStore = rootStore.rootUiStore.qrConfigStore
                      codeListViewState.pageTemplateSelectStore.clearSelectedConfig()
                      codeListViewState.pageTemplateSelectStore.setStyles(rowSnapshot?.dataDetail?.styles)

                      // Initialize preview modal state using shared function
                      const { previewCodeAndEditDesignState } = await initPreviewModalState({
                        rowSnapshot,
                        rootStore,
                        qrConfigSelectStore,
                        qrConfigStore,
                        codeListState: codeListViewState,
                        mediaFileSelectState,
                        dimensionsMultiSelectStore: rootStore.rootUiStore.dimensionsMultiSelectState,
                        tagSelectStore: rootStore.rootUiStore.tagSelectStore
                      });

                      // Show preview modal
                      codeListViewState.handleRowClick(PreviewCodeAndEditDesign, rowSnapshot.name, previewCodeAndEditDesignState, "xl", "preview-experience", rowSnapshot);


                    }}><Icon.Image/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.preview.defaultMessage"/>
      </DropdownItem>,
      <DropdownItem id="action-btn-view" key={'view/' + row.uuid} onClick={() => {
        routerStore.goTo('editCode', {
          params: {id: row.uuid},
          queryParams: {isEditable: 'false'}
        });
      }}><Icon.FileText/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.view.defaultMessage"/>
      </DropdownItem>,
      <DropdownItem id="action-btn-edit" key={'edit/' + row.uuid} onClick={() => {
        if(row.status !== 'DRAFT' && !requiredRolesCheck(CODE_PUBLISH_SET, userRoles)) return

        routerStore.goTo('editCode', {
          params: {id: row.uuid},
        });
      }}><Icon.Edit/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.edit.defaultMessage"/>
      </DropdownItem>,
      <DropdownItem id="action-btn-clone" key={'new'} onClick={() => {
        if(row.status !== 'DRAFT' && !requiredRolesCheck(CODE_PUBLISH_SET, userRoles)) return

        // Check if the code has static behavior and if the feature is disabled
        const staticBehaviorEnabled = rootStore?.appConfigs?.configs?.static_behavior_enabled;
        const snapshot = getSnapshot(row);
        if (snapshot.behavior === codeBehavior.STATIC && !staticBehaviorEnabled) {
          new Notification()
            .setType("info")
            .setTitle("Static feature disabled")
            .setMessage("STATIC behavior is not enabled for the tenant. Cannot clone this static code.")
            .send();
          return;
        }
        console.log("CodeListView: length of snapShot when clone is clicked: ", JSON.stringify(snapshot).length);
        rootStore.rootUiStore.addCloneToCache(`clone:${row.uuid}`,snapshot);
        routerStore.goTo('createCode',{
          queryParams: {q: row.uuid}
        })
      }}><Icon.Copy/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.clone.defaultMessage"/>
      </DropdownItem>,
      ////////////////////////////////// download is in view action ////////////////////////////////////////////////////
      // <DropdownItem key={'download' + row.uuid} value={"Download " + row.uuid} className="align-text-bottom"
      //               onClick={() => {
      //                 const componentStore = QrDownloadState.create({title: "Download"});
      //                 codeListViewState.handleRowClick(row, componentStore, QrDownloadView);
      //               }}><Icon.Download/>&nbsp;Download
      // </DropdownItem>,
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      <>
        {row.status !== "PUBLISHED" && (
          <DropdownItem id="action-btn-publish" key={'publish' + row.uuid} value={"Publish " + row.uuid} className="align-text-bottom"
                        onClick={() => {
                          if(!requiredRolesCheck(CODE_PUBLISH_SET, userRoles)) return

                          const componentStore = PublishState.create(
                            {
                              codeListStore: codeListViewState,
                              title: `Publish ${row.name ? row.name : ""}`,
                              uuid: row.uuid
                            }
                          );
                          componentStore.setPublishStateListener(codeListViewState.modalStore.toggle);
                          componentStore.setSecondPublishStateListener(codeListViewState.publishRow);
                          componentStore.setThirdPublishStateListener(codeListViewState.fetchRow);
                          codeListViewState.handleRowClick(PublishView, `Publish ${row.name ? row.name : ""}`, componentStore);

                        }}><Icon.Send/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.publish.defaultMessage"/>
          </DropdownItem>
        )}
        {row.status === "PUBLISHED" && (
          <DropdownItem id="action-btn-complete" key={'complete' + row.uuid} value={"Complete " + row.uuid} className="align-text-bottom"
                        onClick={() => {
                          if(!requiredRolesCheck(CODE_PUBLISH_SET, userRoles)) return

                          const componentStore = CompleteState.create(
                            {
                              codeListStore: codeListViewState,
                              title: `Complete ${row.name ? row.name : ""}`,
                              uuid: row.uuid
                            }
                          );
                          componentStore.setCompleteStateListener(codeListViewState.modalStore.toggle);
                          componentStore.setSecondCompleteStateListener(codeListViewState.completeRow);
                          componentStore.setThirdCompleteStateListener(codeListViewState.fetchRow);
                          codeListViewState.handleRowClick(CompleteView, `Complete ${row.name ? row.name : ""}`, componentStore);

                        }}><Icon.Send/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.complete.defaultMessage"/>
          </DropdownItem>
        )}
      </>,
      <>
        {codeListViewState.isAuditActionEnabled && (
          <DropdownItem
            id="action-btn-audit"
            key={'audit' + row.uuid}
            value={"audit " + row.uuid}
            className="align-text-bottom"
            onClick={() => {
              const auditSelectStore = rootStore.rootUiStore.auditSelectStore;
              const componentStore = AuditViewState.create({
                codeListStore: codeListViewState,
                uuid: row.uuid,
                auditSelectStore: auditSelectStore
              });

              componentStore?.setModalListener(codeListViewState.modalStore.toggle);
              componentStore?.setAuditStateListener(codeListViewState.auditRow);
              codeListViewState?.setAuditStateRef(componentStore);
              componentStore?.setSelectValue();
              componentStore?.fetchAll();
              codeListViewState?.handleRowClick(AuditView, `Audit ${row.name ? row.name : ""}`, componentStore, "xl");
              componentStore?.setColumns(buildAuditColumns(componentStore, auditOptions));
            }}
          >
            <BadgeCheckIcon className="badge-check-icon" />&nbsp;
            <FormattedMessage id="listCodes.actions.dropdown.audit.defaultMessage" />
          </DropdownItem>
        )}
      </>,
      <DropdownItem key={'divider-1' + row.uuid} divider/>,
      ...(["url","gs1"].includes(row.type) && row.behavior !== "STATIC" ? [<DropdownItem id="action-btn-simulate" key={'simulate/' + row.uuid} onClick={() => {
        routerStore.goTo('simulateCode', {
          params: {id: row.uuid},
        });
      }}><Icon.Activity/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.simulate.defaultMessage"/>
      </DropdownItem>,
      <DropdownItem key={'divider-2' + row.uuid} divider/>,] : []),
      <DropdownItem id="action-btn-delete" key={row.uuid} value={"Delete " + row.uuid} className="align-text-bottom"
      onClick={() => {
        if(row.status !== 'DRAFT' && !requiredRolesCheck(CODE_PUBLISH_SET, userRoles)) return
        if(row.status === 'DRAFT' && !requiredRolesCheck([Roles.DRAFT,...CODE_PUBLISH_SET], userRoles)) return

      const componentStore = DeleteState.create(
    {
      codeListStore: codeListViewState,
      title: `Delete ${row.name ? row.name : ""}`,
      uuid: row.uuid
    });
      componentStore.setDeleteStateListener(codeListViewState.modalStore.toggle)
      componentStore.setSecondDeleteStateListener(codeListViewState.deleteRow)
      codeListViewState.setDeleteStateRef(componentStore);
      codeListViewState.handleRowClick( DeleteView,`Delete ${row.name ? row.name : ""}`,componentStore);

    }}> <Icon.Delete/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.delete.defaultMessage"/>
      </DropdownItem>]}/>))

  const allColumns = [c1, c3, c2, c5, createdBy, updatedBy, hasRules, auditStatus, c4, updatedColumn, actionCol];

  return buildColumnsWithOptionalSupport(allColumns, codeListViewState, rootStore);
}

/**
 *
 * @param codeListState - CodeListState
 */




const CodeListView = observer(({codeListState}) => {
  const routerStore = useRouterStore();
  const intl = useIntl();
  //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  codeListState.setOnSelectChanges()
  const stateContext = useContext(StateContext);
  //TODO: PATTERN VIOLATION - Multiple filter setters called on every render (lines 466-476)
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  codeListState?.codeFilterSelectState.setEmails(codeListState?.store?.filters?.users);
  codeListState?.codeFilterSelectState.setCodeTypes(codeListState?.store?.filters?.types);
  codeListState?.codeFilterSelectState.setStatusTypes(codeListState?.store?.filters?.status)
  codeListState?.codeFilterSelectState.setDomains(codeListState?.store?.filters?.domains)
  codeListState?.codeFilterSelectState.setBehaviorTypes(codeListState?.store?.filters?.behaviors)
  codeListState?.codeFilterSelectState.setAuditStatus(codeListState?.store?.filters.auditLabels)
  codeListState?.tagFilterSelectState.setTags(codeListState?.store?.filters?.tags)
  codeListState?.codeFilterSelectState.setAuditEnabled(codeListState?.isAuditActionEnabled);
  codeListState?.filterGroup && codeListState?.groupFilterSelectState?.setGroups(codeListState?.store?.filters?.groups)
  codeListState?.dimensionSelectViewState?.setFilteredDimensions(codeListState?.store?.filters.dimensions);
  codeListState?.loadFiltersFromSessionStorage()
  const mediaFileSelectState = stateContext.rootUiStore.mediaFileSelectState
  // const qrPreviewStore = stateContext.rootUiStore.qrPreviewStore

  const onRowClicked = async (row, event) => {
    console.log(row)
    // Snapshot row data immediately to avoid MST "no longer part of state tree" errors
    const rowSnapshot = getSnapshot(row);

    const qrConfigSelectStore = stateContext.rootUiStore.qrConfigSelectStore
    const qrConfigStore = stateContext.domainStore.qrConfigStore
    const dimensionsMultiSelectStore = stateContext.rootUiStore.dimensionsMultiSelectState
    const tagSelectStore = stateContext.rootUiStore.tagSelectStore;

    // vCard-specific logic
    if (rowSnapshot?.type === 'vcard') {
      codeListState.pageTemplateSelectStore.clearSelectedConfig()
      codeListState.pageTemplateSelectStore.setStyles(rowSnapshot?.dataDetail?.styles)
    }

    // Initialize preview modal state using shared function
    const { previewCodeAndEditDesignState } = await initPreviewModalState({
      rowSnapshot,
      rootStore: stateContext,
      qrConfigSelectStore,
      qrConfigStore,
      codeListState,
      mediaFileSelectState,
      dimensionsMultiSelectStore,
      tagSelectStore
    });

    // Update experience data and show preview modal
    codeListState.updateExperienceData(rowSnapshot.data)
    codeListState.handleRowClick(PreviewCodeAndEditDesign, rowSnapshot.name, previewCodeAndEditDesignState, "xl", "preview-experience", rowSnapshot);
  }

  const handleItemClick = (item) => {
    const componentState = CreateQrFromTemplateState.create({
      title: item?.name,
      uuid: item?.uuid,
      formSchema: item?.inputSchema,
    });
    stateContext.rootUiStore.attachPageState('createQrFromTemplateState', componentState)
    codeListState.handleClick(componentState,CreateQrFromTemplateView);
  };

  const isDimensionsVisible = codeListState?.dimensionSelectViewState?.dimensionsEnabled && codeListState?.dimensionSelectViewState?.dimensionSelectStates?.length > 0;

  const optionalColumns = stateContext?.appConfigs?.configs?.optional_columns || ['updatedBy'];
  console.log("optionalCOlumns", optionalColumns);

  // Get column name mapping from state
  const columnNameMapping = codeListState.columnNameMapping || {};


  console.log("columnNameMapping", columnNameMapping);

  return (
  <>
      <Card>
        <CardBody>
          <Row className="mb-2">
            <Col className="d-flex justify-content-end filter-actions-container">
              {codeListState.isFilterVisible ? (
                <Button
                  id="codelist-dropdown-open"
                  color="primary"
                  onClick={() => codeListState.toggleFilterVisible()}
                >
                  <FontAwesomeIcon icon={faAngleDoubleUp} />
                </Button>
              ) : (
                <Button
                  id="codelist-dropdown-closed"
                  color="primary"
                  onClick={() => codeListState.toggleFilterVisible()}
                >
                  <FontAwesomeIcon icon={faAngleDoubleDown} />
                </Button>
              )}

              <OptionalColumnsDropdown
                listViewState={codeListState}
                buildColumnsFunction={buildColumns}
                idPrefix="code-col"
              />
            </Col>
          </Row>
          {codeListState.isFilterVisible && <>
            <Row>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({id: "filterByGroups.defaultMessage"})}
                  </InputGroupAddon>
                  {/*<CodeOwnerFilterSelect codeOwnerFilterSelectState={codeListState.codeOwnerFilterSelectState}/>*/}
                  {/*<GroupSelect groupSelectStore={codeListState.groupSelectStore} multi={true}/>*/}
                  <GroupFilterSelect groupFilterSelectState={codeListState.groupFilterSelectState}/>
                </InputGroup>
              </Col>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({id: "listCodes.filter.filterName.defaultMessage"})}
                  </InputGroupAddon>
                  <CodeFilterSelect codeFilterSelectState={codeListState.codeFilterSelectState}/>
                </InputGroup>
              </Col>
              {!isDimensionsVisible && <><ResetButton viewState={codeListState}/>
                <ExportButton viewState={codeListState}/> </>}
            </Row>
            <Row className="filter-row-align-end">
              <Col sm={10}>
                <Row>
                  {codeListState?.dimensionSelectViewState?.dimensionsEnabled && codeListState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => buildDimensionFilters(dimensionSelectStore, 6))}
                </Row>
              </Col>
              {isDimensionsVisible && <><ResetButton viewState={codeListState}/>
                <ExportButton viewState={codeListState}/> </>}
            </Row>
            <Row>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({id: "listCodes.searchInput.defaultMessage"})}
                  </InputGroupAddon>
                  <Input
                    type="text"
                    name="searchInput"
                    placeholder="Search"
                    onChange={codeListState.onSearchChange}
                    value={codeListState.searchTxt}
                  />
                </InputGroup>
              </Col>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({id: "listCodes.filterBytags.defaultMessage"})}
                  </InputGroupAddon>
                  <TagFilterSelect tagFilterSelectState={codeListState.tagFilterSelectState}/>
                </InputGroup>
              </Col>
              <Col sm={1}>
                <CustomInput
                  type="switch"
                  id="isFilterTypeOR"
                  name="isFilterTypeOR"
                  label={formConstants.Mode.OR}
                  checked={codeListState.isFilterTypeOR}
                  onChange={() => codeListState.selectFilterMethod()}
                />
              </Col>
              <Col sm={0.5}  >
                <InputGroup className="justify-content-end">
                  <RouterLink routeName="createCode">
                    <Button id="create-code-btn" color="primary" className="create-code-button"><FormattedMessage id="listCodes.create.defaultMessage"/></Button>
                  </RouterLink>
                  <QrTemplateSelect qrtemplateSelectStore={codeListState.qrtemplateSelectStore}
                                    onItemClick = {handleItemClick} />
                </InputGroup>
              </Col>
            </Row>
          </>}
          <ScanbuyTable
            key={codeListState?.columns.length}
            columns={codeListState.columns}
            store={codeListState.store}
            isElasticSearchEnabled = {codeListState.isElasticSearchEnabled}
            queryParams={{}}
            onRowClicked={onRowClicked}
            highlightOnHover={true}
            pointerOnHover={true}
            state={codeListState}
            useCursorPagination={codeListState.isElasticSearchEnabled && codeListState?.store?.actualTotalRows > codeListState?.store?.esWindowLimit}
          />
        </CardBody>
      </Card>
      <GenericModal
        modalStore={codeListState.modalStore}
        componentStore={codeListState.modalComponentStore}
        EmbedComponent={codeListState.modalComponent}
        size={codeListState.modalSize}
        className={codeListState.modalClassName}
        onBeforeClose={() => stateContext.rootUiStore.detachPageState('previewCodeAndEditDesignState')}
      />
    <GenericModal2
      modal2Store={codeListState.modal2Store}
      componentStore={codeListState.modal2ComponentStore}
      EmbedComponent={codeListState.modal2Component}
      size={codeListState.modal2Size}
      className={codeListState.modal2ClassName}
    />
      <GenericToastView genericToastState={codeListState.toastStore}/>
    </>
  );
})

const ResetButton = observer(({viewState}) => {
  const stateContext = useContext(StateContext);
  const routerStore = useRouterStore();

  return(
    <>
      <Col sm={1}>
        <div></div>
      </Col>
      <Col sm={0.5} className="reset-button-col" >
        <InputGroup>
          <Button id="filter-rest-button" color="primary" onClick={()=>viewState?.clearFilters()}>
            <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
        </InputGroup>
      </Col>
      <UncontrolledTooltip target="filter-rest-button" placement="top">
        <FormattedMessage id="createQr.resetBtn.defaultMessage"/>
      </UncontrolledTooltip>
    </>
  );
});


export default CodeListView;
